import ErrorMessage from "../Form/ErrorMessage";
import Label from "../Label/Label";
import PropTypes from "prop-types";
import React from "react";
import clsx from "clsx";
import styles from "./DropdownField.module.scss";

const SelectComponent = ({ selectProps, placeholder, renderChoices, choices }) => {
  return (
    <select {...selectProps}>
      <option value="" disabled>
        {placeholder}
      </option>
      {renderChoices ||
        choices.map((choice, i) => (
          <option data-testid="choice" key={i} value={choice}>
            {choice}
          </option>
        ))}
    </select>
  );
};

const DropdownFieldComponent = (
  {
    color,
    choices = [],
    className = "",
    defaultValue,
    disabled,
    required,
    errors = {},
    label,
    labelType,
    colorLabel,
    name = "",
    placeholder,
    renderChoices,
    errorMessages = {},
    dataTestId,
    onChange,
  },
  ref
) => {
  const containerClasses = clsx(styles.dropdownField, className);

  const IS_ERROR = errors[name];

  const colorClass = (type) => !IS_ERROR && !disabled && color === type;

  const selectClasses = clsx("form-control", {
    [styles.invalid]: IS_ERROR,
    [styles.primary]: colorClass("primary"),
    [styles.warning]: colorClass("warning"),
    [styles.success]: colorClass("success"),
    [styles.secondary]: colorClass("secondary"),
  });

  return (
    <div className={containerClasses} data-testid={dataTestId}>
      {label ? (
        <Label
          disabled={disabled}
          color={colorLabel}
          htmlFor={name}
          required={required}
          type={labelType}
        >
          {label}
        </Label>
      ) : null}
      <SelectComponent
        selectProps={{
          className: selectClasses,
          disabled: disabled,
          ref: ref,
          name: name,
          id: name,
          defaultValue: defaultValue,
          required: required,
          onChange: onChange,
        }}
        placeholder={placeholder}
        choices={choices}
        renderChoices={renderChoices}
      />
      <ErrorMessage errorMessages={errorMessages} errors={errors} label={label} name={name} />
    </div>
  );
};

const DropdownField = React.forwardRef(DropdownFieldComponent);

SelectComponent.propTypes = {
  selectProps: PropTypes.shape({
    defaultValue: PropTypes.any,
    disabled: PropTypes.bool,
    required: PropTypes.bool,
    choices: PropTypes.array,
    onChange: PropTypes.func,
    className: PropTypes.any,
    id: PropTypes.string,
    name: PropTypes.string,
  }),
};

DropdownField.propTypes = {
  defaultValue: PropTypes.any,
  disabled: PropTypes.bool,
  errors: PropTypes.shape({
    type: PropTypes.string,
    message: PropTypes.string,
  }),
  errorMessages: PropTypes.object,
  label: PropTypes.string,
  colorLabel: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  dataTestId: PropTypes.string,
  choices: PropTypes.array,
  onChange: PropTypes.func,
  color: PropTypes.string,
};

DropdownField.defaultProps = {
  defaultValue: "",
  disabled: false,
  errors: {},
  errorMessages: {},
  label: "",
  colorLabel: "",
  name: "",
  placeholder: "",
  required: false,
  dataTestId: "DropdownField",
  choices: [],
  color: "primary",
};
export default DropdownField;
